import React from 'react';
import { AuthContextInterface, withAuthContext } from './Context';

type SignInButtonProps = AuthContextInterface & {isAuthenticated: boolean};

function SignInButton(props: SignInButtonProps): JSX.Element {
    const onClick = (event: any) => {
        event.preventDefault();
        if (props.auth.isAuthenticated()) {
            props.auth.redirectToSignOut();
        } else {
            props.auth.redirectToSignIn();
        }
    };

    return (
        <a onClick={onClick}>{props.isAuthenticated ? 'Sign out' : 'Sign in'}</a>
    );
}

export default withAuthContext(SignInButton);
